import { createSvgIcon } from "@material-ui/core";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 -960 960 960",
  children: /*#__PURE__*/_jsx("path", {
    d: "m812-703-34-75-75-34 75-34 34-75 34 75 75 34-75 34-34 75Zm-482 0-34-75-75-34 75-34 34-75 34 75 75 34-75 34-34 75Zm482 482-34-75-75-34 75-34 34-75 34 75 75 34-75 34-34 75ZM187-92l-95-95q-11-11-12-25.5T92-240l450-450q12-12 29-12t29 12l90 90q12 12 12 29t-12 29L240-92q-12 12-26.5 12T187-92Zm383-416 62-62-62-62-62 62 62 62Z"
  })
}), "AutoFixHighFilled");